export default "__VITE_ASSET__39a004f3__"